var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09089 0.509033C1.38799 0.509033 0 1.89703 0 3.59992V9.05449C0 10.7574 1.38799 12.1454 3.09089 12.1454H12.9091C14.612 12.1454 16 10.7574 16 9.05449V3.59992C16 1.89703 14.612 0.509033 12.9091 0.509033H3.09089ZM3.09089 1.60001H12.9091C14.0266 1.60001 14.9092 2.48261 14.9092 3.60008V9.05465C14.9092 10.1721 14.0266 11.0547 12.9091 11.0547H3.09089C1.97342 11.0547 1.09082 10.1721 1.09082 9.05465V3.60008C1.09082 2.48261 1.97342 1.60001 3.09089 1.60001ZM6.72727 3.96369V8.69098L10.7273 6.3273L6.72727 3.96369Z",
    fill: "#67768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.4f705fedc0c3fd1985b8e02e370c8f5c.svg";
export { ForwardRef as ReactComponent };